import { IconButton } from '@mui/material'
import React from 'react'
import './Mail.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ErrorIcon from '@mui/icons-material/Error';
import EmailIcon from '@mui/icons-material/Email';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from "react-router-dom";
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import PrintIcon from '@mui/icons-material/Print';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LabelImportant from '@mui/icons-material/LabelImportant';
import { selectselectedmail } from './features/mailSlice';
import {useSelector} from "react-redux";

function Mail() {
  const history = useNavigate();
  const selectedmail = useSelector(selectselectedmail);
    function handleSubmit(e) {
        e.preventDefault();

        history('/');
    }
  return (
    <div className='mail'>
      <div className='mail_tools'>
        <div className='mail_toolsleft'>
        <IconButton onClick={handleSubmit}>
          <ArrowBackIcon/>
          </IconButton>
          <IconButton>
  <MoveToInboxIcon/>
          </IconButton>
          <IconButton>
  <ErrorIcon/>
          </IconButton>
          <IconButton>
  <EmailIcon/>
          </IconButton>
          <IconButton>
<WatchLaterIcon/>
          </IconButton>
          <IconButton>
            <CheckCircleIcon/>
          </IconButton>
          <IconButton>
<MoreVertIcon/>
          </IconButton>
        </div>
        <div className='mail_toolsright'>
<IconButton>
<UnfoldMoreIcon/>
</IconButton>
<IconButton>
<PrintIcon/>
</IconButton>
<IconButton>
  <ExitToAppIcon/>
</IconButton>
        </div>
       
      </div>
      <div className='mail_body'>
      <div className='mail_bodyheader'>
        <h2>{selectedmail?.subject}</h2>
        <LabelImportant className='mail_important'/>
        <p>{selectedmail?.title}</p>
        <p className='mail_time'>{selectedmail?.time}</p>
      </div>
      <div className='mail_message'>
<p>{selectedmail?.description}</p>
      </div>
      </div>
    </div>
  )
}

export default Mail